export enum AUTO_TRANSLATION {
    /**
     * @value Translate to %LANGUAGE_LABEL%
     * @description Displays the label of the translation action when the content is not translated.
     * The %LANGUAGE_LABEL% represent the name of the language for example: Translate to English
     */
    CONTEXTUAL_ACTIONS_TRANSLATION_OFF_ACTION = 'LUMX.CONTEXTUAL_ACTIONS_TRANSLATION_OFF_ACTION',
    /**
     * @value Translated in %LANGUAGE_LABEL%
     * @description Displays the label of the translation action when the content is already translated.
     * The %LANGUAGE_LABEL% represent the name of the language for example: Translated in English
     */
    CONTEXTUAL_ACTIONS_TRANSLATION_ON_ACTION = 'LUMX.CONTEXTUAL_ACTIONS_TRANSLATION_ON_ACTION',
    /**
     * @value Rate limit exceeded.
     * Please log in to increase your quota.
     * @description The error message when the rate limit to the Translation API call is exceeded for a non-connected user. It invites the user to log in in order to get rid of the limitation.
     */
    NOT_LOGGED_RATE_LIMIT_EXCEEDED = 'AUTO_TRANSLATION.NOT_LOGGED_RATE_LIMIT_EXCEEDED',
}
